import { Box, Typography } from '@mui/joy';

export function EmptyMealTypeState({ text = 'No meals planned', isDragging = false }) {
  return (
    <Box
      sx={{
        py: 2,
        textAlign: 'center',
        borderRadius: 'md',        
        outline: isDragging ? '1px dashed transparent' : '1px dashed var(--joy-palette-neutral-400)',
      }}
    >
      <Typography level="body-xs">{text}</Typography>
    </Box>
  );
}

